import React from 'react';
import { Box, BoxProps } from '@mui/material';

const PreviewContainer: React.FC<BoxProps> = ({ children, sx, ...props }) => {
  return (
    <Box
      sx={[
        {
          maxWidth: {
            sm: 1,
            md: '85vw',
            xl: 1200,
          },
          width: 1,
          mx: 'auto',
          my: 6,
          px: 4,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    >
      {children}
    </Box>
  );
};

export default PreviewContainer;
